export const GET_ALL_DEPOSITS = 'app/ManageDeposits/GET_ALL_DEPOSITS';
export const GET_ALL_DEPOSITS_SUCCESS =
  'app/ManageDeposits/GET_ALL_DEPOSITS_SUCCESS';
export const GET_ALL_DEPOSITS_ERROR =
  'app/ManageDeposits/GET_ALL_DEPOSITS_ERROR';

export const CLEAR_LOADED_DEPOSITS = 'app/ManageDeposits/CLEAR_LOADED_DEPOSITS';

export const SORT_DEPOSITS_BY_DATE = 'app/ManageDeposits/SORT_DEPOSITS_BY_DATE';
